import React, {useState} from 'react';
import {Avatar, Dropdown, message, Spin} from 'antd';
import {LogoutOutlined, SettingOutlined, UserOutlined} from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import {useLogoutMutation} from "../slices/rootApiSlices/authApiSlice";
import {logout} from "../slices/authSlice";
import UserModal from "./UserModal";

const UserProfile = () => {

    const {user} = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isModalVisible, setIsModalVisible] = useState(false);

    const [logoutHandle, {isLoading}] = useLogoutMutation()

    const handleLogout = async () => {
        try {
            await logoutHandle(user?.token).unwrap()
            dispatch(logout())
            navigate('/auth/sign-in')
        } catch (err) {
            message.error(err?.data?.messageTR || err?.error)
        }
    }

    const handleModalOpen = () => {
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
    };

    const items = [
        {
            key: '1',
            label: (
                <>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center"
                        }}
                        onClick={handleModalOpen} // Open modal on click
                    >
                        <Avatar size="large" icon={<UserOutlined/>}/>
                        <div style={{marginLeft: '8px'}}>
                            <div style={{fontSize: 17, fontWeight: '500'}}>{user?.name}</div>
                            <div style={{fontSize: 14, fontWeight: '400'}}>{user?.email}</div>
                        </div>
                    </div>
                </>
            ),
        },
        {
            key: '2',
            label: (
                <>
                    <Link to="/settings">
                        Ayarlar
                    </Link>
                </>
            ),
            icon: <SettingOutlined style={{fontSize: 15}}/>,
        },
        {
            key: '3',
            label: (
                <>
                    <Link onClick={handleLogout} to="">
                        Çıkış Yap
                    </Link>
                </>
            ),
            icon: <LogoutOutlined style={{fontSize: 15}}/>,
        },
    ];

    return (
        <div style={{marginRight: '10px', cursor: "pointer", marginBottom: '3px'}}>
            <Dropdown
                menu={{
                    items,
                }}
                trigger={['click']}
            >
                {isLoading ? <Spin/> :
                    <Avatar style={{backgroundColor: '#011529'}} shape="square" icon={<UserOutlined/>}/>}
            </Dropdown>
            <UserModal
                isModalVisible={isModalVisible}
                handleModalClose={handleModalClose}
            />
        </div>
    );

};

export default UserProfile;
